<template>
  <section
    :style="data.style ? data.style :  isDark ? 'secondary' : ''"
    :class="`${isDark ? 'secondary white--text' : ''} ${data.class}`"
  >
    <v-container :class="`about ${ isDark ? 'white--text' : ''}`">
      <v-row justify="center" align="center">
        <v-col cols="12" class="text-center">
          <h1 class="text-center">{{data.title}}</h1>
        </v-col>
        <v-col cols="12" class="text-center">
          <v-row justify="center">
            <v-col cols="11" sm="10" md="8" lg="6" xl="5">
              <v-card>
                <v-img
                  :aspect-ratio="16/9"
                  :src="data.video.thumbnail"
                  @click="$eventBus.$emit('play_video',data.video.url)"
                >
                  <v-row class="pa-2 fill-height">
                    <v-fade-transition>
                      <v-overlay :absolute="true" :value="true" :opacity="0.2">
                        <v-btn color="primary">
                          <v-icon small>fa-play</v-icon>
                        </v-btn>
                      </v-overlay>
                    </v-fade-transition>
                  </v-row>
                </v-img>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col cols="11" sm="10" md="3" lg="3" xl="2" v-for="(tile,t) in data.tiles" :key="t">
          <h3 class="text-left text-md-center">{{tile.title}}</h3>
          <p class="text-left text-md-center" v-html="tile.description"></p>
        </v-col>
      </v-row>
      <v-row v-if="data.link">
        <v-col class="text-center" cols="12">
          <span v-if="data.link.url">
            <a
              target="_blank"
              v-if="data.link.url.startsWith('http')"
              :href="data.link.url"
            >{{data.link.text}}</a>
            <router-link v-else :to="data.link.url">{{data.link.text}}</router-link>
          </span>
          <span
            v-else-if="data.link.video"
            class="clicky primary--text"
            @click="$eventBus.$emit('play_video',data.link.video)"
          >{{data.link.text}}</span>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
export default {
  name: "PageAbout",
  props: ["value"],
  data() {
    return {};
  },
  computed: {
    data() {
      return this.value;
    },
    isDark() {
      return this.value.dark ? true : false;
    }
  }
};
</script>

<style lang="scss">
.about a {
  text-decoration: none;
}
.vx {
  /* Extra small devices (phones, 600px and down) */
  @media only screen and (max-width: 600px) {
    padding: 20px;
  }

  /* Small devices (portrait tablets and large phones, 600px and up) */
  @media only screen and (min-width: 600px) {
    padding: 20px;
  }

  /* Medium devices (landscape tablets, 768px and up) */
  @media only screen and (min-width: 768px) {
    padding: 10px;
  }

  /* Large devices (laptops/desktops, 992px and up) */
  @media only screen and (min-width: 992px) {
    padding: 50px;
  }

  /* Extra large devices (large laptops and desktops, 1200px and up) */
  @media only screen and (min-width: 1200px) {
    padding: 50px;
  }
}
</style>